/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagingHeader } from '../models/PagingHeader';
import type { Site } from '../models/Site';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import { requestHdr as __requestHdr } from '../core/request';
import { requestApiResult as __requestApiResult } from '../core/request';
import { ApiResult } from '../core/ApiResult';


export class SiteService {

    /**
     * @param pagingHeader 
     * @param filter 
     * @returns VmcStatusDto Success
     * @throws ApiError
     */
    public static async get(token: string,
        pagingRange: string,
        filter?: Record<string, string>,
        search?: Record<string, string>
): Promise<ApiResult> {
        return await __requestApiResult(OpenAPI, {
            method: 'GET',
            url: `/api/Sites`,
            headers: {                
                Range: `sites=${pagingRange}`,
                Authorization: `Bearer ${token}`
            },
            query: {
                'filter': filter,
                'search': search
            },
            responseHeader: 'Content-Range'
        });
    }

    /**
     * @param id 
     * @returns VmcStatusDto Success
     * @throws ApiError
     */
    public static async get1(token: string,
id: string,
): Promise<Site> {
        return await __request(OpenAPI, {
            method: 'GET',
            url: `/api/Sites/${id}`,
            headers: { Authorization: `Bearer ${token}` }
        });
    }

    public static async getTotalCount(token: string,
        filter?: Record<string, string>,
        search?: Record<string, string>
    ): Promise<string> {
        return await __requestHdr(OpenAPI, {
            method: 'GET',
            url: '/api/Sites',
            headers: { Range: 'locations=0-1', Authorization: `Bearer ${token}` },
            query: {
                'filter': filter,
                'search': search
            },
            responseHeader: 'Content-Range'
        });
    }

    /**
     * @param id 
     * @param requestBody 
     * @returns any Success
     * @throws ApiError
     */
    public static async put(token: string,
        id: number,
        requestBody?: Site,
    ): Promise<any> {
        const result = await __request(OpenAPI, {
            method: 'PUT',
            url: `/api/Sites/${id}`,
            headers: { Authorization: `Bearer ${token}` },
            body: requestBody,
        });
        return result;
    }

    public static async descriptions(token: string
    ): Promise<any> {
        const result = await __request(OpenAPI, {
            method: 'GET',
            url: `/api/Sites/descriptions`,
            headers: { Authorization: `Bearer ${token}` }
        });
        return result;
    }

    public static async type(token: string, siteId: string
    ): Promise<string> {
        const result = await __request(OpenAPI, {
            method: 'GET',
            url: `/api/Sites/type/${siteId}`,
            headers: { Authorization: `Bearer ${token}` }
        }) as string;
        return result;
    }
    
    /**
     * @param requestBody
     * @returns Site Success
     * @throws ApiError
     */
    public static async post(token: string,
        requestBody?: Site,
    ): Promise<number> {
        return await __request(OpenAPI, {
            method: 'POST',
            url: `/api/Sites`,
            headers: { Authorization: `Bearer ${token}` },
            body: requestBody,
        });
    }

    public static async propertyInfo(token: string
    ): Promise<any> {
        const result = await __request(OpenAPI, {
            method: 'GET',
            url: `/api/Sites/propertyInfo`,
            headers: { Authorization: `Bearer ${token}` }
        });
        
        return result;
    }
}